import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout"; //

const routes = constructRoutes(
  document.querySelector("#single-spa-layout") as HTMLTemplateElement
);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach(registerApplication);
layoutEngine.activate();
start();

// when all applications are unloaded, hide the top menu
window.addEventListener("single-spa:before-app-change", (e:any) => {
  const topmenus = document.querySelector(".top-right-menu");
  if(topmenus)
    (topmenus as HTMLElement).style.display = "none";
});

// register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {


    const requestNotificationPermission = async () => {
      const permission = await window.Notification.requestPermission();
      // value of permission can be 'granted', 'default', 'denied'
      // granted: user has accepted the request
      // default: user has dismissed the notification permission popup by clicking on x
      // denied: user has denied the request.
      if (permission !== "granted") {
        console.error("Permission not granted for Notification: " + permission);
      }
    };

    requestNotificationPermission().then(() => {

      navigator.serviceWorker.register('/service-worker.js').then(registration => {
      }).catch(registrationError => {
        console.error('SW registration failed: ', registrationError);
      });

    }).catch((err) => {
      console.error('SW request failed: ', err);
    })

  });

}